export function buildBuilderQueryString(searchParams) {
	const qs = searchParams.toString();
	return qs ? `?${qs}` : "";
}
